import fetch from '@/plugins/axios'
export default {
	namespaced: true,
	state: {
        userList: [],
		userPager: {},
		excom: [], //快递公司
		partnerList: [], //快递员列表
		partnerPager: {},
		loading: false
	},
	mutations: {
		setState(state: any, { key, data }: any) {
			state[key] = data;
		},
		// 修改单价后，改变本地数据
		changeList(state: any, obj: any) {
			state['partnerList'][obj.index].price = obj.val;
		}
    },
	actions: {
		// 添加用户
		async addClientUser({ commit }: any, params: any) {
			return await fetch({
				url: '/admin/clientUser',
				method: 'post',
				data: params
			})
		},
        // 获取用户列表
		async getCustomerList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
                url: '/admin/clientUser',
                params
			})
			res.docs.forEach((item:any) => {
				item.subscribe_time = new Date(parseInt(item.subscribe_time) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ')
			})
            commit('setState',{key:'userList',data: res.docs})
			commit('setState',{key:'userPager',data: {limit: res.limit,total: res.total}})
			commit('setState',{key:'loading',data: false})
		},
		// 获得快递公司
		async getExcom({ commit }: any, params: any) {
			const res = await fetch({
				url: '/common/getExcom'
			})
			commit('setState',{key:'excom',data:res})
		},
		// 获取快递员列表
		async getPartnerList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
				url: '/admin/partner',
				method: 'get',
				params
			})
			commit('setState',{key:'partnerList',data: res.docs})
			commit('setState',{key:'partnerPager',data: {limit: res.limit,total: res.total}})
			commit('setState',{key:'loading',data: false})
		},
		// 修改快递员单价
		async modifyPartnerPrice({ commit }: any, params: any) {
			return await fetch({
				url: `/admin/partner/${params.id}`,
				method: 'put',
				data: params.data
			})
		},
		// 删除快递员
		async deletePartner({ commit }: any, id: string) {
			return await fetch({
				url: `/admin/partner/${id}`,
				method: 'delete'
			})
		},
		// 查看快递员详情 
		async getPartnerDetail({ commit }: any, id: string){
			return await fetch({
				url: `/admin/partner/${id}`,
				method: 'get'
			})
		},
		//添加底价
		async addMinimumPartner({ commit }: any, params: any){
			return await fetch({
				url: `/admin/partner/${params.id}`,
				method: 'put',
				data: params.data
			})
		},
		// 快递员充值
		async partnerRecharge({ commit }: any, params: any) {
			return await fetch({
				url: `/admin/partner/recharge/${params.id}`,
				method: 'put',
				data: params.data
			})
		},
		// 导入快递员 
		async importPartnerFun({ commit }: any, params: any){
			commit('setState',{key:'loading',data: true})
			const res = await fetch({
				url: 'admin/partnerimport', 
				method: 'get',
				params 
			})
			commit('setState',{key:'loading',data: false})
			return res
		},
		adminUserList({ commit }, params: object) {
			return fetch({
				url: 'admin/user',
				method: 'get',
				params 
			})
		},
		createAdminUser({ commit }, data: object) {
			return fetch({
				url: 'admin/user',
				method: 'POST',
				data,
			})
		},
		modifyAdminUser({ commit }, data: any) {
			return fetch({
				url: `admin/user/${data._id}`,
				method: 'PUT',
				data,
			})
		},
		deleteAdminUser({ commit }, id: string) {
			return fetch({
				url: `admin/user/${id}`,
				method: 'DELETE',
			})
		},
		getAdminLogs({ commit }, params: object) {
			return fetch({
				url: 'admin/logs',
				method: 'get',
				params 
			})
		}
	}
}